<div class="bar">
    <div class="bar__block" *ngFor="let barItemIndex of barItems;"
         [ngClass]="{'bar__block--green' : shouldDisplayAsGreenBar(barItemIndex)}">
    </div>
</div>